// extracted by mini-css-extract-plugin
module.exports = {"menu":"NavbarDoctor_menu__1snHy"};